<template>
<button @click="executeButton" v-bind:id="p_customId" v-bind:disabled="p_disabled" class="configurator-button button" v-bind:class="c_customClass">
    <i v-if="p_iconLeft" :class="c_buttonLeftClasses"></i>
    <i v-else-if="p_iconTick" :class="c_buttonTickClasses"></i>
    <i v-else-if="p_iconRight" :class="c_buttonRightClasses"></i>
    <span v-else class="configurator-button-label">{{ p_label }}</span>
</button>
</template>

<script>

export default {
  props: {
    p_label: String,
    p_iconLeft: {
      default: null,
      type: String,
    },
    p_iconRight: {
      default: null,
      type: String,
    },
    p_iconTick: {
      default: null,
      type: String,
    },
    p_customClass: {
      default: null,
      type: String,
    },
    p_notDisabledCustomClass: {
      default: null,
      type: String,
    },
    p_customId: {
      default: null,
      type: String,
    },
    p_disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    c_customClass: function() {
      // if the button is disabled some classes should not be assigned
      if (this.p_disabled) {
        return this.p_customClass;
      }
      if (this.p_notDisabledCustomClass != null)
        return this.p_customClass + " " + this.p_notDisabledCustomClass;
      return this.p_customClass;
    },
    c_buttonLeftClasses: function() {
        return this.p_customClass + ' ' + this.p_iconLeft;
    },
    c_buttonRightClasses: function() {
        return this.p_customClass + ' ' + this.p_iconRight;
    },
    c_buttonTickClasses: function() {
        return this.p_customClass + ' ' + this.p_iconTick;
    },
  },
  methods: {
    executeButton() {
      if (this.p_iconLeft) {
        this.$parent.showPrevStep();
      } 
      else if (this.p_iconRight) {
        this.$parent.showNextStep();
      }
      else {
        this.$parent.executeButton();
      }
    }
  }
};
</script>

<style language="css">
  @import '../../scss/button/style.css';
</style>



// WEBPACK FOOTER //
// src/components/configurator/Button.vue